import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// ---------Shared--------------------------------------------
import { System } from '../../../shared-components/System';
import { UserService } from '../../../shared-components/user/user.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { StudentAttachment } from '../../../shared-modules/student-attachment/student-attachment.model';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { IepService } from '../iep.service';
import { SpedDocumentAttachment } from '../iep.model';

@Component({
  selector: 'app-iep-documents',
  templateUrl: './iep-documents.component.html',
  styles: []
})
export class IepDocumentsComponent implements OnInit {

  docAttachments: SpedDocumentAttachment[] = [];
  columnsToDisplay: string[] = ['DocumentDescription', 'DocumentName', 'CreatedDate', 'AttachedBy'];

  constructor(
    private userService: UserService,
    private studentService: StudentService,
    private iepService: IepService,
    private dialogRef: MatDialogRef<IepDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public document: any
  ) {

  }

  ngOnInit() {
    this.getDocumentAttachments();
  }

  getDocumentAttachments() {
    this.iepService.getSpedDocumentAttachments(this.studentService.selectedStudent.Id, this.document.SpedCollectionToStudentId, this.userService.userId).subscribe(attachments => {
      this.docAttachments = attachments;
    });
  }

  viewAttachmentClick(attachmentId) {
    const studentAttachment: StudentAttachment = {
      DocumentId: attachmentId,
      DocumentName: 'IEPAttachedDocument.pdf',
      DocumentBase64: '',
      DocumentMimeType: '',
      DocumentModuleName: 'Documents',
      ReportParameters: [],
      ReportType: 0
    };

    window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
    const win = window.open(System.baseUrl + 'studentattachment', '_blank');
    win.focus();
  }

  closeClick() {
    this.dialogRef.close('Close was clicked.');
  }

  getAriaRow(row: SpedDocumentAttachment): string {
    const colList: string[] = ['DocumentDescription', 'DocumentName', 'CreatedDate', 'AttachedBy'];
    const dataList: string[] = [row.DocumentDescription, row.DocumentName, new Date(row.CreatedDate).toDateString(), row.AttachedBy];
    return AriaDirective.concatAriaStrings(colList, dataList);
  }
}
